export default __webpack_public_path__ + "static/media/e320ee1fbb7df4136b9c1e745dbc62aaa.c2d93f47.png";